import React from 'react';

import { CircularProgress, FormControl, Select, MenuItem, InputLabel, Avatar, Typography, Box, Checkbox } from '@mui/material';

import i18n from '../../i18n';
import { UsersView } from '../UsersView';

export function UsersSelect({
  selectedUserIds = [],
  loading = false,
  users = [],
  onClose = () => {},
  onBlur =  () => {},
  onChange = () => console.error('OnChange not implemented')
}) {
  if (loading) {
    return (
      <CircularProgress />
    )
  }

  return ( 
    <Select
      id="select-who"
      variant="outlined"
      multiple
      value={selectedUserIds}
      sx={{
        width: '100%'
      }}
      onClose={onClose}
      onBlur={onBlur}
      onChange={(event) => {
        onChange(event.target.value)
      }}
      renderValue={(selected) => (
        <UsersView
          users={users.filter(u => selectedUserIds.find(uid => u.username == uid))}
        />
      )}
    >
      {users?.map(user => (
        <MenuItem key={user.username} value={user.username}>
          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <Checkbox checked={selectedUserIds.find(userId => userId === user.username)} />
            <Avatar sx={{ width: 28, height: 28 }} src={user.imageUrl} />&nbsp;<Typography>{user.firstName} {user.lastName}</Typography>
          </Box>
        </MenuItem>
      ))}
    </Select> 
  )
}